"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOT = void 0;
exports.NOT = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: () => {
        throw new Error('Function:NOT not implemented');
    },
};
//# sourceMappingURL=not.js.map